import { z } from 'zod/v4'
import createComponentSchema from '../util/createComponentSchema'

const ParamMappingConfig = z.object({
  source: z.enum(['state', 'url', 'static']),
  key: z.string().optional(),
  value: z.unknown().optional()
})

const GenericEmbedSchema = createComponentSchema(
  'GenericEmbed',
  z.object({
    target_url: z
      .string()
      .describe('URL of the target sitemodel or external page'),
    iframe_height: z
      .string()
      .optional()
      .describe('Height of the iframe (e.g., "600px", "100%")'),
    iframe_width: z
      .string()
      .optional()
      .describe('Width of the iframe (e.g., "100%", "800px")'),
    params_mapping: z
      .record(z.string(), ParamMappingConfig)
      .optional()
      .describe(
        'Mapping of query parameters: key -> {source, key/value}. Example: {"object_class_uuid": {"source": "state", "key": "UUID_OBJECTCLASS"}}'
      ),
    styleMap: z
      .record(z.string(), z.record(z.string(), z.unknown()))
      .optional()
      .describe(
        'Responsive style mapping with breakpoints (sm, md, lg). Example: {"sm": {"width": "100%"}, "lg": {"width": "80%"}}'
      )
  })
)

export default GenericEmbedSchema
